// MpfSelect.props.ts
// NHS Design System: https://service-manual.nhs.uk/design-system/components/select
import { MpfInputBaseProps, mpfInputDefaults } from '../MpfInput/MpfInputBaseProps';

export interface MpfSelectOptionItem {
  value: string | number | null;
  label: string;
  id?: string;
  disabled?: boolean;
}

export interface MpfSelectProps extends Omit<MpfInputBaseProps, 'modelValue'> {
  type?: 'select';
  modelValue: string | number | null;
  items: MpfSelectOptionItem[];
  includeEmptyOption?: boolean;
  emptyOptionLabel?: string;
}

// Defaults MUST be values (NOT factories) when using withDefaults
export const mpfSelectDefaults = {
  ...mpfInputDefaults,
  type: 'select',
  modelValue: null,
  // Clinical safety, not styling: an empty first option stops a select answering
  // itself with whichever option happens to sort first. Do not flip this default.
  includeEmptyOption: true,
  emptyOptionLabel: '',
} satisfies Partial<MpfSelectProps>;

export type MpfSelectEmits = {
  (e: 'update:modelValue', value: string | number | null): void;
  (e: 'change', value: string | number | null, event: Event): void;
  (e: 'blur', event: FocusEvent): void;
  (e: 'focus', event: FocusEvent): void;
};
